/* @flow */

import { values } from 'lodash'

import type {
  RootState,
  Action,
  PollType,
  PollTypesStore,
  PollTypeId,
} from '../types'
import { upsert, ActionRequiresPropertyError } from '../helpers'

import { hardcodedPollTypes } from '../legacy'

export const CLEAR_POLL_TYPES_STORE: string = 'opinary/CLEAR_POLL_TYPES_STORE'
export const INTO_POLL_TYPES_STORE: string = 'opinary/INTO_POLL_TYPES_STORE'

export function clearPollTypesStore(): Action {
  return {
    type: CLEAR_POLL_TYPES_STORE,
  }
}

export function intoPollTypesStore(items: Array<PollType>): Action {
  return {
    type: INTO_POLL_TYPES_STORE,
    items,
  }
}

export function selectPollTypes(rootState: RootState): Array<PollType> {
  return values(rootState.pollTypesStore)
}

export function selectPollTypeById(
  rootState: RootState,
  id: PollTypeId
): ?PollType {
  return rootState.pollTypesStore[id.toString()]
}

export default function reducer(
  state: PollTypesStore = upsert({}, hardcodedPollTypes),
  action: Action
): PollTypesStore {
  switch (action.type) {
    case INTO_POLL_TYPES_STORE:
      if (!action.items) {
        throw new ActionRequiresPropertyError(INTO_POLL_TYPES_STORE, 'items')
      } else {
        return upsert(state, action.items)
      }
    case CLEAR_POLL_TYPES_STORE:
      return {}
    default:
      return state
  }
}

export function isPollTypeId1D(pollTypeId: PollTypeId): boolean {
  return pollTypeId === 'one-axis'
}

export function isPollTypeId2D(pollTypeId: PollTypeId): boolean {
  return pollTypeId === 'two-axes'
}

export function isPollTypeIdRanking(pollTypeId: PollTypeId): boolean {
  return pollTypeId === 'ranking'
}

export function isPollTypeIdSlider(pollTypeId: PollTypeId): boolean {
  return pollTypeId === 'slider'
}



// WEBPACK FOOTER //
// ./src/stores/pollTypesStore.js